import React from 'react';

import { AVATAR_SIZES } from '@atlaskit/avatar/avatar-sizes';
import { token } from '@atlaskit/tokens';
import { css } from '@atlaskit/css';

import type { IconSize } from './templateIconTypes.ts';

type DefaultIconProps = {
	size?: IconSize;
	children: React.ReactNode;
};

const defaultIconCss = css({
	paddingTop: token('space.050'),
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	backgroundColor: token('color.background.accent.gray.bolder'),
});

const smallSize = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${AVATAR_SIZES['small']}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${AVATAR_SIZES['small']}px`,
});

const mediumSize = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${AVATAR_SIZES['medium']}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${AVATAR_SIZES['medium']}px`,
});

const largeSize = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${AVATAR_SIZES['large']}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${AVATAR_SIZES['large']}px`,
});

const iconStyles = css({
	boxSizing: 'border-box',
	margin: 0,
	marginRight: token('space.050'),
	padding: 0,
	flexShrink: 0,
	flexGrow: 0,
	alignSelf: 'flex-start',
	boxShadow: 'initial',
});

const sizeMapping = {
	small: smallSize,
	medium: mediumSize,
	large: largeSize,
} as const;

export const DefaultIcon = ({ children, size = 'medium' }: DefaultIconProps): React.JSX.Element => {
	return (
		<div data-testid="template-icon-default" css={[defaultIconCss, sizeMapping[size], iconStyles]}>
			{children}
		</div>
	);
};
